import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { AuthService } from "../../shared/services/auth.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }


  getProducts(page: number, pageSize: number): Observable<any> {
    let params = new HttpParams()
    params = params.append('Page', page);
    params = params.append('PageSize', pageSize);

    return this.http.get<any>(this.url('/product-registration'), { params });
  }

  enableDisableWallet(wallet: any) {
    return this.http.post(`${environment.apiUrl}/wallet/enable`, wallet);
  }
  
  add(product: any) {
    return this.http.post(`${environment.apiUrl}/productRegistration`, product);
  }
}
